import { render } from "./PropertyDetailView.vue?vue&type=template&id=2c61dc52&scoped=true"
import script from "./PropertyDetailView.vue?vue&type=script&lang=js"
export * from "./PropertyDetailView.vue?vue&type=script&lang=js"

import "./PropertyDetailView.vue?vue&type=style&index=0&id=2c61dc52&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c61dc52"]])

export default __exports__